module.exports = __webpack_public_path__ + "static/media/eg.2ea321dd.svg";